import { useMutation } from '@tanstack/react-query';
import type { ChatMessage } from './types';

export function useSendMessage(onAnswer: (m: ChatMessage) => void) {
    return useMutation({
        mutationFn: async (content: string) =>
            (await (
                await fetch('/api/ref-coreai/messages', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ content }) })
            ).json()) as ChatMessage,
        onSuccess: onAnswer,
    });
}
